export default function () {
  return useState('debugMode', () => true)
}
